module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('core-header', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('core-nav-main', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "account",
    attrs: {
      "md-row": "",
      "md-align": "center",
      "md-vertical-align": "center"
    }
  }, [_c('md-layout', {
    staticClass: "layout-separator",
    attrs: {
      "md-flex": "100"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "account-subscription-status",
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [(_vm.user.active_pay) ? _c('div', [_c('span', [_vm._v("Subscription Status: "), _c('strong', [_vm._v("Collaborator")])])]) : _c('div', [_c('span', [_vm._v("Subscription Status: "), _c('strong', [_vm._v("Observer")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.upgradeSubscription
    }
  }, [_vm._v("Upgrade")])], 1)]), _vm._v(" "), _c('md-layout', {
    staticClass: "layout-separator",
    attrs: {
      "md-flex": "100"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "60"
    }
  }, [_c('md-avatar', {
    staticClass: "md-xxlarge"
  }, [(_vm.user.profile_picture) ? _c('img', {
    attrs: {
      "src": _vm.user.profile_picture,
      "alt": "People"
    },
    on: {
      "click": _vm.openDialog
    }
  }) : _c('img', {
    attrs: {
      "src": require('../assets/img/silhouette.jpg'),
      "alt": "People"
    },
    on: {
      "click": _vm.openDialog
    }
  }), _vm._v(" "), (_vm.user.signInMethod === 'email') ? _c('md-tooltip', {
    attrs: {
      "md-direction": "right",
      "md-delay": "500"
    }
  }, [_vm._v("Click to upload a new photo")]) : _c('md-tooltip', {
    attrs: {
      "md-direction": "right",
      "md-delay": "500"
    }
  }, [_vm._v("Update your user profile photo in your Google account settings.")])], 1), _vm._v(" "), _c('profile-photo', {
    ref: "imageUpload"
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "layout-separator",
    attrs: {
      "md-flex": "100"
    }
  }), _vm._v(" "), (_vm.editingName) ? _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-offset": "35",
      "md-align": "center"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.saveName($event)
      }
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.new_username),
      callback: function($$v) {
        _vm.new_username = $$v
      },
      expression: "new_username"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.cancelEditingName
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.saveName
    }
  }, [_vm._v("Save")])], 1)]) : _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [_c('div', {
    staticClass: "md-headline ql-user-name",
    on: {
      "click": _vm.editName
    }
  }, [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), (_vm.user.signInMethod === 'email') ? _c('md-tooltip', [_vm._v("click to change")]) : _c('md-tooltip', [_vm._v("Update your user name in your Google account settings.")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "layout-separator",
    attrs: {
      "md-flex": "100"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-offset": "35",
      "md-align": "center"
    }
  }, [(_vm.user.signInMethod === 'email') ? _c('change-password') : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "layout-separator",
    attrs: {
      "md-flex": "100"
    }
  })], 1), _vm._v(" "), _c('core-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52e0fbba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/views/account.vue
// module id = 652
// module chunks = 2